import registerDiagnostics from '../actions/registerDiagnostics';
import setSessionDetails from '../mutators/setSessionDetails';
import { getDiagnosticsLogState } from '../store/store';
import { lazyGenerateDiagnosticReport } from 'owa-diagnostic-report';
import { renderFindMeetingTimesDiagnostics } from '../components/FindMeetingTimesDiagnostics';

export default () => {
    lazyGenerateDiagnosticReport.import().then(util => setSessionDetails(util()));
    registerDiagnostics(
        {
            name: 'Cas',
            type: 'Cas',
            datapoints: [],
            selected: null,
        },
        getDiagnosticsLogState(),
        () => renderFindMeetingTimesDiagnostics()
    );
};
